import axios from "axios";
import { translateError } from "@/i18n/errors";
import { useEffect, useState, useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ptg_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function expireAuth(token) {
  if (token && localStorage.getItem("ptg_token") === token) {
    localStorage.removeItem("ptg_token");
    window.dispatchEvent(new Event("ptg-auth-expired"));
  }
}
http.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 401 && !/^\/auth\/(login|register|whatsapp)$/.test(error.config?.url || "")) {
    expireAuth(error.config?.headers?.Authorization?.replace(/^Bearer /, ""));
  }
  return Promise.reject(error);
});

export function formatErr(e) {
  if (e?.response?.status >= 500) return translateError("server");
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.response ? translateError("invalid") : translateError("network");
  if (typeof detail === "string") return translateError(detail);
  if (Array.isArray(detail)) return translateError("invalid");
  return translateError(detail.msg || String(detail));
}

export const idr = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");

export const gmapsDir = (lat, lng) => `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

export const waLink = (num, text) => `https://wa.me/${num}?text=${encodeURIComponent(text)}`;

export function useApi(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const load = useCallback(() => {
    if (!path) { setLoading(false); return Promise.resolve(); }
    setLoading(true); setError("");
    return http.get(path).then((r) => setData(r.data)).catch((e) => { setError(formatErr(e)); setData(null); }).finally(() => setLoading(false));
  }, [path]);
  useEffect(() => { load(); }, [load]);
  return { data, loading, error, reload: load, setData };
}
